// extracted by mini-css-extract-plugin
module.exports = {"block":"ePotP","body":"HO1Kc","content":"uO6Lb","open":"bh2NG","overflowHidden":"jhpnz","button":"isJ6V","buttonIcon":"vRpjC"};